import type { DataProvider, Identifier } from "ra-core";

import type { Contact } from "../types";

type EventInput = {
  contact_id: Identifier;
  sales_id?: Identifier | null;
  type: string;
  body: string;
};

export async function recordLeadEvent(
  dataProvider: DataProvider,
  event: EventInput,
) {
  try {
    await dataProvider.create("lead_events", {
      data: {
        ...event,
        created_at: new Date().toISOString(),
      },
    });
  } catch (error) {
    console.error(error);
  }
}

export async function syncDealsToStage(
  dataProvider: DataProvider,
  contact: Contact,
  stage: string,
  lostReason?: string | null,
) {
  try {
    const { data: deals } = await dataProvider.getList("deals", {
      filter: {},
      pagination: { page: 1, perPage: 200 },
      sort: { field: "id", order: "ASC" },
    });
    const linked = deals.filter((deal) =>
      (deal.contact_ids ?? []).map(String).includes(String(contact.id)),
    );
    await Promise.all(
      linked.map((deal) =>
        dataProvider.update("deals", {
          id: deal.id,
          data: {
            stage,
            ...(lostReason ? { lost_reason: lostReason } : {}),
          },
          previousData: deal,
        }),
      ),
    );
  } catch (error) {
    console.error(error);
  }
}
